import React from 'react';
import {connect} from 'react-redux';
import {deleteFromCart, getCartItems} from "../../store/actions/cart";
import {removeLocation, storeLocation} from "../../store/actions/location";
import Price from '../../shared/price';
import Total from './Total';
import ContactForm from '../Forms/ContactForm';
import CreditCardForm from '../Forms/CreditCardForm';
import ThankYou from '../ThankYou/ThankYou';
import {FaExclamation, FaShoppingCart} from 'react-icons/fa';
import './Cart.css';
import {getProducts} from '../../store/actions/products';
import {clearCoupon, clearCouponOff} from "../../store/actions/coupon";

class Cart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCart: true
        };
    }

    componentDidMount() {
        this.props.getCartItems();

        if (this.props.match.url) {
            this.props.storeLocation(this.props.match.url);
        }

        if (!this.props.indexedProduct) {
            this.props.getProducts();
        }

    }

    componentWillUnmount() {
        if (this.props.match.url) {
            this.props.removeLocation();
        }

        if (this.props.coupon) {
            this.props.clearCoupon();
        }
    }

    toggleContactForm() {
        this.setState({showCart: false});
    }


    render() {
        let costs = [];
        let colorModel;
        let popupButtonColors;
        if (this.props.portalSettings) {
            colorModel = this.props.portalSettings.pageBody.colorModel;

            popupButtonColors = {
                backgroundColor: colorModel.popupButtonBackgroundColor,
                color: colorModel.popupButtonFontColor
            };
        }
        let cartItems = this.props.cartItems.map((item, index) => {
            costs.push(parseFloat(item.amountSelected));

            if (this.props.indexedProducts) {
            }

            return (
                <div key={index} className="cart-item">
                    <button
                        type="button"
                        className="remove-from-cart-btn"
                        style={popupButtonColors}
                        onClick={() => this.props.deleteFromCart(item.id)}
                    >
                        X
                    </button>
                    <br/>
                    <img src={item.designUrl} alt="Cart Thumbnail" className="cart-img"/>
                    <p className="cart-item-price"><Price price={parseFloat(item.amountSelected)}/></p>
                    {item.gift ?
                        <div className="giftInfoBox">
                            <div><b>Recipient Name:</b> {item.toFirstName} {item.toLastName}</div>
                            <div><b>Recipient Email:</b> {item.toEmail}</div>
                            <div><b>From Email:</b> {item.fromEmail}</div>
                        </div>
                        :
                        null
                    }

                </div>
            );
        });


        let cart = (
            <div className="cart">
                <h1>Your Shopping Cart</h1>
                <div className="cart-items">
                    {cartItems}
                </div>
                {/*
                <Coupon/>
*/}
                <Total costs={costs}/>
                <button
                    type="button"
                    onClick={() => this.toggleContactForm()}
                    className="checkoutBtn"
                    style={popupButtonColors}

                >
                    Proceed to checkout
                </button>
            </div>
        );

        let subPage;
        if (this.state.showCart && this.props.cartItems.length > 0) {
            subPage = cart
        } else if (this.state.showCart) {
            subPage = <div className="emptyCartMsg"><FaShoppingCart size="3em"/>

                <h3>Your cart is empty!</h3>
                <div
                    onClick={() => this.props.history.push('/')}
                    className="checkoutBtn cartBackButton">Return
                </div>

            </div>
        } else if (!this.props.user) {
            subPage = <ContactForm
                showCreditCardForm={() => this.setState({showCreditCardForm: true, showContactForm: false})}/>
        } else if (this.props.user && !this.props.transactions) {
            subPage = <CreditCardForm/>
        } else {
            subPage = <ThankYou/>
        }


        return (
            <div className="cart-container">
                {
                    /* if coupon is no longer valid, this message renders */
                    this.props.couponOff ?
                        <div className="modal">
                            <div className="modal-form">
                                <FaExclamation size={100}/>
                                <h3>Sorry, this coupon is no longer valid.</h3>
                                <button
                                    type="button"
                                    className="modal-button"
                                    onClick={() => this.props.clearCouponOff()}
                                >
                                    Okay
                                </button>
                            </div>
                        </div> :
                        null
                }
                {subPage}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    cartItems: state.cartReducer.cart,
    indexedProduct: state.productsReducer.indexedProduct,
    indexedProducts: state.productsReducer.indexedProducts,
    location: state.locationReducer.location,
    user: state.userReducer.data,
    transactions: state.transactionsReducer.finished,
    coupon: state.couponReducer.coupon,
    couponOff: state.couponReducer.couponOff,
    portalSettings: state.portalSettingsReducer.portalSettings
});

const mapDispatchToProps = dispatch => ({
    storeLocation: (url) => dispatch(storeLocation(url)),
    removeLocation: () => dispatch(removeLocation()),
    clearCoupon: () => dispatch(clearCoupon()),
    clearCouponOff: () => dispatch(clearCouponOff()),
    getProducts: () => dispatch(getProducts()),
    deleteFromCart: (id) => dispatch(deleteFromCart(id)),
    getCartItems: () => dispatch(getCartItems())
});

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
